export default {
      id: "color_bacteria_cloud-usage",
      viewBox: "0 0 152 181",
      url: __webpack_public_path__ + "sprite.svg#color_bacteria_cloud",
      toString: function () {
        return this.url;
      }
    }